import React from 'react';

import { Grid } from '@mui/material';
import { get, isEmpty, keys } from 'lodash';
import Info from './Info';

function DeliverableAddressInfo({ data, id }) {
  if (isEmpty(data) || isEmpty(get(data, `deliverable_address`, {}))) return 'No data';

  const key = keys(get(data, `deliverable_address`, {}))[0];
  const deliverableAddressInfo = get(data, `deliverable_address.${key}`, {});
  const pins = get(deliverableAddressInfo, `pins`, []);

  return (
    <Grid container spacing={2}>
      <Info label={'Deliverable Address ID'} value={get(deliverableAddressInfo, `id`, '-')} />
      <Info
        label={'Address'}
        value={`${get(deliverableAddressInfo, `address.street`, '-')} - ${get(deliverableAddressInfo, `address.street2`, '-')}, ${get(deliverableAddressInfo, `address.city`, '-')},
        ${get(deliverableAddressInfo, `address.state`, '-')} ${get(deliverableAddressInfo, `address.zipcode`, '-')}`}
      />
      {!isEmpty(pins) && (
        <>
          <Grid size={12} style={{ fontWeight: '600', fontSize: 14 }}>
            Pins:
          </Grid>
          {pins?.map((pin, i) => (
            <Grid size={12} style={{ fontSize: 14, color: '#777' }} key={`pin-${i}`}>
              Pin {pin.type || i + 1}: {pin.latitude?.toFixed(6)}, {pin.longitude?.toFixed(6)}
            </Grid>
          ))}
        </>
      )}
    </Grid>
  );
}

export default DeliverableAddressInfo;
